import React, { useState } from 'react';
import {
  Box,
  Stack,
  Dialog,
  Button,
  Tooltip,
  Typography,
  IconButton,
  DialogTitle,
  DialogContent,
  CircularProgress,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import BackupRoundedIcon from '@mui/icons-material/BackupRounded';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';

import graph from './graph';
import schema from './schema';
import uiSchema from './uiSchema';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';
import { MuiFormBuilder, NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle } from 'components';

export default function CreateBulk({ title = 'آپلود فایل', refetch }) {
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [attachment, setAttachment] = useState(null);
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [addBulk, { loading }] = useMutation(graph.bulk.query, {
    context: {
      serviceName: graph.bulk.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onChangeFile = ({
    target: {
      validity,
      files: [file],
    },
  }) => {
    if (validity.valid) {
      setAttachment(file);
      setFile(file);
    }
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await addBulk({
        variables: {
          ...formData,
          file,
          type: 'UPDATE_PRODUCTSHOP',
          update_type: formData?.update_type ? 'FULL' : 'SINGLE',
          booth_stock_status: formData?.booth_stock_status ? 'REAL' : 'UNREAL',
        },
      });
      if (!isEmptyObject(data) && !errors) {
        refetch();
        onClose();
        const { messages } = data[graph.bulk.name];
        messages.map((message) => toast.success(String(message)));
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  const onSubmitForm = ({ formData }) => {
    return setFormData(formData);
  };

  return (
    <>
      <IconButton
        size="medium"
        color="secondary"
        loading={loading}
        onClick={onOpen}
        sx={{ bgcolor: 'secondary.lighter' }}
      >
        <BackupRoundedIcon color="secondary" fontSize="small" />
      </IconButton>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle
          title={title}
          onClose={onClose}
          actions={
            <IconButton size="small" color="info" aria-label="close" onClick={onClose} sx={{ bgcolor: 'info.lighter' }}>
              <AttachFileRoundedIcon fontSize="small" />
            </IconButton>
          }
        ></NewDialogTitle>
        <NewDialogContent isPopup>
          <Stack p={1} rowGap={2} borderRadius={3} bgcolor="#fff">
            <input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              style={{ display: 'none' }}
              id="file"
              name="file"
              type="file"
              multiple={false}
              onChange={onChangeFile}
            />
            <label htmlFor="file">
              <Stack
                minHeight={250}
                borderRadius={3}
                border="1px dashed"
                alignItems="center"
                justifyContent="center"
                borderColor="text.disabled"
                sx={{ transition: 'all 0.5s ease', ':hover': { bgcolor: '#f1f1f1', transition: 'all 0.7s ease' } }}
              >
                <Typography color="text.secondary" fontSize={80}>
                  {loading ? <CircularProgress size={80} /> : <BackupRoundedIcon fontSize="inherit" />}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {attachment?.name || 'انتخاب فایل'}
                </Typography>
                <Typography variant="caption" color="text.disabled">
                  {attachment?.size ? `${(attachment.size / 1024).toFixed(2)} کیلوبایت` : ''}
                </Typography>
              </Stack>
            </label>
            {/* <Form formData={formData} onChange={setFormData} /> */}
            <MuiFormBuilder
              id="createBulk"
              showSubmit={false}
              liveValidate={false}
              schema={schema()}
              uiSchema={uiSchema()}
              formData={formData}
              onSubmit={onSubmitForm}
              onChange={onSubmitForm}
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button size="large" variant="contained" onClick={onSubmit} loading={loading} disabled={!file}>
            بارگذاری
          </Button>
          {/* <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="createBulk"
            variant="contained"
            disabled={loading}
          >
            تایید و ادامه
          </Button> */}
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
